import { z } from 'zod';

// Notification types
export const notificationTypeSchema = z.enum([
  'portal_access',
  'file_download',
  'file_view',
  'portal_shared',
  'system',
  // Predictive alerts
  'project_inactive',
  'project_due_soon',
  'project_overdue',
]);

export type NotificationType = z.infer<typeof notificationTypeSchema>;

// Notification schema
export const notificationSchema = z.object({
  id: z.string(),
  userId: z.string(),
  type: notificationTypeSchema,
  title: z.string(),
  message: z.string(),
  data: z.record(z.unknown()).nullable(),
  readAt: z.string().nullable(),
  createdAt: z.string(),
});

export type Notification = z.infer<typeof notificationSchema>;

// Response schemas
export const notificationsResponseSchema = z.object({
  notifications: z.array(notificationSchema),
  unreadCount: z.number(),
});

export type NotificationsResponse = z.infer<typeof notificationsResponseSchema>;
